import { Component , ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController , Slides } from 'ionic-angular';

import { OperadorInfopedidoPage } from '../operador-infopedido/operador-infopedido';
import { OperadorPackingPage } from '../operador-packing/operador-packing';
import { OperadorPedidosPage } from '../operador-pedidos/operador-pedidos';

import { Services, Tools, User, Api } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-operador-operacao',
  templateUrl: 'operador-operacao.html',
})

export class OperadorOperacaoPage {
  @ViewChild('SwipedTabsSlider') SwipedTabsSlider: Slides ;

  nav:string='0';
  progress:string='0';
  pedidosNome:any;
  produtosPendentes:any=[];
  produtosPendentesNovos:any[];
  produtosConcluidos:any=[];
  produtosCancelados:any=[];
  tabs:any=[];
  tabsColor:any=[];
  pedido:any={
    pedidosId:[],
    items:[]
  };
  postObj:any={};
  separacaoLocal:any={};
  viewProd:any=false

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private api:Api,
    public user: User,
    private tools:Tools,
    private services:Services
  ){}

  ionViewDidLoad(){

    console.log('ionViewDidLoad OperadorOperacaoPage');
    this.pedido = this.navParams.get('item');
    this.pedido
    console.log('This pedido',this.pedido);

    this.produtosPendentes = this.pedido.items.filter(e=>!e.conferido && !e.cancelado);
    this.produtosConcluidos = this.pedido.items.filter(e=>e.conferido);
    this.produtosCancelados = this.pedido.items.filter(e=>e.cancelado);

    this.tabs=[`Pedentes (${this.produtosPendentes.length})`,`Concluídos (${this.produtosConcluidos.length})`,`Cancelados (${this.produtosCancelados.length})`];
    this.tabsColor = ['darkorange','green','red'];

    var nomes = this.pedido.items.map(e=>e.codigo);
    this.pedidosNome = nomes.filter(function(item, pos){
      return nomes.indexOf(item) == pos;
    });
    this.calcProgress();

    var codigos = this.pedido.items.map(e=>e.codigoBarra);

    var codigosLimpos = codigos.filter((item, pos) => { return codigos.indexOf(item) == pos; });

    this.buscarProdutos(codigosLimpos);
  }

  buscarProdutos(codigosBarra){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    let self = this;
    var urlBuscarProdutos = 'http://barbosa.ibrs.com.br:5000/api/tracking/buscarprodutosimg';

    this.postObj = {codigos:codigosBarra};
    // console.log('chegou');

    this.sendPost(urlBuscarProdutos,(result)=>{
      console.log('Log result',result);
      console.log(result.data.length);
      var produtos = result


      if(result.status && result.data && result.data.length>0){
        for(var x1 in result.data){

          var prod = this.pedido.items.find(f=>f.codigoBarra == result.data[x1].sku);
          if(prod && result.data[x1].linkId){
            prod.img = `http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${result.data[x1].linkId}/-1`;

            prod.categoria = result.produtos.find(e => e.sku == prod.codigoBarra).categoria
            prod.categoriaSecundaria = result.produtos.find(e => e.sku == prod.codigoBarra).categoriaSecundaria
            prod.departamento = result.produtos.find(e => e.sku == prod.codigoBarra).departamento

            console.log(`http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${result.data[x1].linkId}/-1`);
            // console.log(prod);
            // prod.sort()
          }
        }
        // console.log('thsi pedidos', this.pedido.items);
        // this.pedido.items.sort()
        // console.log('sort pedidos', this.pedido.items);
      this.produtosPendentesNovos = this.pedido.items.filter(e=>!e.conferido && !e.cancelado);
      console.log(this.produtosPendentesNovos);

      this.produtosPendentesNovos.sort((a,b) => (a.categoria > b.categoria) ? 1 : ((b.categoria > a.categoria) ? -1 : 0));
      console.log(this.produtosPendentesNovos);
      this.produtosPendentes = this.produtosPendentesNovos


        setTimeout(() => {
          loading.dismiss();
        }, 500);

      }else{
        self.tools.showAlert('toast',`${result.msg}`,1500);
        loading.dismiss();
      }
    });
  }

  sendPost(url,callback){
    var self = this;
    this.api.sendPost(url,self.postObj,{},function(result){
      callback(result);
    });
  }

  calcProgress(){
    this.progress = ((100*this.produtosConcluidos.length/this.pedido.items.filter(e=>!e.cancelado).length)+'').split('.')[0];
  }

  changeNav(event) {
    this.produtosPendentes = this.pedido.items.filter(e=>!e.conferido && !e.cancelado);
    this.produtosConcluidos = this.pedido.items.filter(e=>e.conferido && !e.cancelado);
    this.produtosCancelados = this.pedido.items.filter(e=>e.cancelado);
    this.tabs=[`Pedentes (${this.produtosPendentes.length})`,`Concluídos (${this.produtosConcluidos.length})`,`Cancelados (${this.produtosCancelados.length})`];
  }

  showPedidos(){
    const alert = this.alertCtrl.create({
      title: `Separação: ${this.pedido.codigo}`,
      subTitle: `${this.pedidosNome.join(', ')}`,
      buttons: ['OK']
    });
    alert.present();
  }

  openPedido(produto){
    console.log('Produto OpenPedido', produto);
    this.viewProd = true;
    this.services.getData('cadPedidos',{'pedido.codigo':produto.codigo},(result)=>{
      var pedido = result.data[0];
      this.navCtrl.push(OperadorInfopedidoPage,{item:pedido});
    });
  }

  ionViewCanLeave(): boolean{
    console.log('ionViewCanLeave entrou');

    let loading = this.tools.showLoading('Carregando...');

    if(this.viewProd){
      console.log('IF this.viewProd');
      this.viewProd = false;
    }else{
      loading.present();
      console.log('IF this.viewProd');
      this.navCtrl.setRoot(OperadorPedidosPage, {item:loading});
    }

    return true;
  }

  swipeEvent(event) {
    var index = this.SwipedTabsSlider.getActiveIndex();

    if(event.deltaX > 0){
      // console.log("Swipe Esquerda > Direita");
      if(index != 0){
        var a = index-1;
        this.SwipedTabsSlider.slideTo(a, 100);
        document.getElementById("indicator").style.transform = `translate3d(-10%,0,0)`;
      }
    }else{
      // console.log("Swipe Direita > Esquerda");
      if(index != 2){
        var b = index+1;
        this.SwipedTabsSlider.slideTo(b, 100);
        document.getElementById("indicator").style.transform = `translate3d(100%,0,0)`;
      }
    }
  }

  openPack(item,type){
    var idx = this.pedido.items.findIndex(e=>e.codigo == item.codigo && e.codigoBarra == item.codigoBarra);

    let modal = this.modalCtrl.create(OperadorPackingPage,{separacao:this.pedido, idx:idx, caixas:this.pedido.caixas});
    modal.present();

    var self = this;

    modal.onDidDismiss((items, reqs) => {
      console.log(items);
      console.log(reqs);

      if(items && items.length>0){
        this.pedido.items = items;

        this.tools.storage('load','separacao',null,(e)=>{
          console.log(e);

          if(e.status){
            this.separacaoLocal = JSON.parse(e.data);

            if(this.separacaoLocal.codigo != this.pedido.codigo){
              this.tools.showAlert('toast','Pedido Diferente No LS, Mudando');
              this.separacaoLocal = this.pedido;
            }else{
              this.separacaoLocal.items = this.pedido.items;
            }

            this.separacaoLocal.timeupd = new Date().getTime();

            self.tools.storage('save','separacao',JSON.stringify(this.separacaoLocal),(resultS) => {
              if(resultS.status){
                // self.tools.showAlert('toast','Pedido LS Atualizado');
              }
            });

          }else{
            if(e.msg == "Não encontrado"){
              self.tools.storage('save','separacao',JSON.stringify(this.separacaoLocal),(resultS) => {
                if(resultS.status){

                }else{
                  this.tools.showAlert('toast','Erro ao salvar LS');
                }
              });
            }
          }

        });

        this.produtosPendentes = this.pedido.items.filter(e=>!e.conferido && !e.cancelado);
        this.produtosConcluidos = this.pedido.items.filter(e=>e.conferido && !e.cancelado);
        this.produtosCancelados = this.pedido.items.filter(e=>e.cancelado);

        this.tabs=[`Pedentes (${this.produtosPendentes.length})`,`Concluídos (${this.produtosConcluidos.length})`,`Cancelados (${this.produtosCancelados.length})`];
      }
      this.calcProgress();
    });
  }

  finalizar(){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    var url = 'http://barbosa.ibrs.com.br:5000/api/tracking/finalizarsep';

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "separacaoId":this.pedido._id+''
    }

    let self = this;
    this.api.sendPost(url,postObj,{},function(result){
      console.log('result: ',result);
      if(result.status){
        self.tools.storage('del','separacao',null,(e)=>{
          console.log(e);
          self.navCtrl.setRoot(OperadorPedidosPage,{item:loading});
          self.tools.showAlert('toast',result.msg);
        });
      }else{
        self.tools.showAlert('toast',result.msg);
        loading.dismiss();
      }
    });
  }

  ///Slider/////////

  selectTab(index){
    var aux = 100*index;
    document.getElementById("indicator").style.transform = `translate3d(${aux+'%'},0,0)`;
    this.SwipedTabsSlider.slideTo(index, 500);
  }

  updateIndicatorPosition(){
    if( this.SwipedTabsSlider.length()> this.SwipedTabsSlider.getActiveIndex()){
      var aux:any = this.SwipedTabsSlider.getActiveIndex() * 100;
      document.getElementById("indicator").style.transform = `translate3d(${aux+'%'},0,0)`;
    }
  }

  animateIndicator($event){
    var progress = $event.progress * (this.SwipedTabsSlider.length()-1)
    var aux = progress * 100;

    if(document.getElementById("indicator")){
      document.getElementById("indicator").style.transform = `translate3d(${aux+'%'},0,0)`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/operador-operacao/operador-operacao.ts